import { render, staticRenderFns } from "./sportsMapping.vue?vue&type=template&id=ea99d080"
import script from "./sportsMapping.vue?vue&type=script&lang=js"
export * from "./sportsMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports